import React from "react";
import ProfilePic from "../Image/Image.jpeg";

const About = () => {
  return (
    <section
      id="about"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "100px 50px",
        backgroundColor: "#000000ff",
        color: "#fff",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        gap: "50px",
      }}
    >
      {/* Left: Text */}
      <div style={{ flex: 1, textAlign: "center" }}>
        <h1 style={{ fontSize: "3rem", marginBottom: "10px" }}>Hey There!</h1>
        <h2 style={{ fontSize: "2rem", marginBottom: "15px" }}>
          I'm Shreeya Dinesh Desai.
        </h2>
        <p style={{ fontSize: "1.2rem", marginBottom: "25px", color: "#ccc" }}>
          MSc Cloud Computing Graduate | Aspiring Cloud & IT Professional.
        </p>
        <a
          href="/Shreeya Desai.pdf" // replace with your CV path
          style={{
            display: "inline-block",
            padding: "12px 25px",
            backgroundColor: "#00b894",
            color: "#fff",
            borderRadius: "5px",
            textDecoration: "none",
            fontWeight: "600",
            transition: "0.3s",
          }}
        >
          Download CV
        </a>
      </div>

      {/* Right: Image */}
      <div style={{ flex: 1, textAlign: "center" }}>
        <img
          src={ProfilePic}
          alt="Shreeya Dinesh Desai"
          style={{
            width: "350px",
            borderRadius: "10px",
            boxShadow: "0 15px 30px rgba(0,0,0,0.5)",
          }}
        />
      </div>
    </section>
  );
};

export default About;
